<template>
  <swiper :options="swiperOption">
    <swiper-slide class="list1" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.preview.list1.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.preview.list1.desc')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide v-if="false" class="list2" :class="$i18n.locale"><!-- 스펙아웃 대상 : 오픈 베타 이후 -->
      <div class="swiper-content--wrap">
        <div class="img--wrap">
          <figure>
            <img src="../../assets/img/page/regi_guide_4-2-1.png" alt="registration guide image">
            <figcaption v-html="$t('page.registration.guide.preview.list2.figCaption.before')"></figcaption>
          </figure>
          <i class="icon icon--arrow-gray-size20"></i>
          <figure>
            <img src="../../assets/img/page/regi_guide_4-2-2.png" alt="registration guide image">
            <figcaption v-html="$t('page.registration.guide.preview.list2.figCaption.after')"></figcaption>
          </figure>
        </div>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.preview.list2.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.preview.list2.desc')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide v-if="false" class="list3" :class="$i18n.locale"><!-- 스펙아웃 대상 : 오픈 베타 이후 -->
      <div class="swiper-content--wrap">
        <div class="img--wrap">
          <figure>
            <img src="../../assets/img/page/regi_guide_4-3-1.png" alt="registration guide image">
          </figure>
          <i class="icon icon--arrow-gray-size20"></i>
          <figure>
            <img src="../../assets/img/page/regi_guide_4-3-2.png" alt="registration guide image">
          </figure>
        </div>
        <p class="figure-caption" v-html="$t('page.registration.guide.preview.list3.figCaption')"></p>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.preview.list3.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.preview.list3.desc')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev icon icon--prev-white-size20" slot="button-prev"></div>
    <div class="swiper-button-next icon icon--prev-white-size20" slot="button-next"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>
